import { Observable } from 'rxjs';
import { MapperFunctions } from './mapper-functions';

export abstract class BaseMapper {
  abstract mapperId: MapperFunctions;
  abstract map: (value: unknown, model: unknown, params?: unknown) => Observable<unknown>;
}
